import { z } from 'zod';

export const LangCode = z.enum(['pl', 'en', 'de', 'cs', 'uk']);
export type LangCode = z.infer<typeof LangCode>;

export const CountryCode = z.enum(['PL', 'DE', 'CZ', 'UA']);
export type CountryCode = z.infer<typeof CountryCode>;

export const CurrencyCode = z.enum(['PLN', 'EUR', 'CZK', 'UAH']);
export type CurrencyCode = z.infer<typeof CurrencyCode>;

export const SiteConfig = z.object({
  site_code: z.string().min(2).max(8),
  host: z.string().regex(/^[a-z0-9.-]+$/),
  default_lang: LangCode,
  supported_langs: z.array(LangCode).min(1),
  default_currency: CurrencyCode,
  country_code: CountryCode,
  brand_settings: z.record(z.unknown()).default({}),
});
export type SiteConfig = z.infer<typeof SiteConfig>;
